import { Box, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { StyledTab, StyledTabs } from "./AdminSettingPanel";
import AircraftGroupExternalLinkageAircraft from "./AircraftGroupExternalLinkageAircraft";
import AircraftGroupLinkageAircraft from "./AircraftGroupLinkageAircraft";
import AircraftGroupLinkageUserGroup from "./AircraftGroupLinkageUserGroup";
import AircraftGroupList from "./AircraftGroupSettingList";
import AircraftList from "./AircraftSettingList";

const useStyles = makeStyles({
	settingTopBox: {
		display: 'flex',
		flexDirection: 'column',
	},
	settingTab: {
	},
	settingBody: {
		flexGrow: 1,
		marginTop: '-1px',
		border: '1px solid #a7a7a7',
		overflow: 'hidden',
	},
});

export const AircraftSettingMenu = Object.freeze({
	AIRCRAFT: 0,
	AIRCRAFT_GROUP: 1,
	AIRCRAFT_LINKAGE: 2,
	AIRCRAFT_LINKAGE_EXTERNAL: 3,
	USER_GROUP_LINKAGE: 4,
});

export function AircraftSettingBox({changeCoPilotSetting}) {
	const [value, setValue] = useState(AircraftSettingMenu.AIRCRAFT);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const changeAircraftSettingMenu = useCallback((page) => {
		setValue(page);
	}, []);

	const classes = useStyles();
	const {t} = useTranslation();

	const Pager = () => {
		switch(value) {
			case AircraftSettingMenu.AIRCRAFT:
				return <AircraftList />;
			case AircraftSettingMenu.AIRCRAFT_GROUP:
				return <AircraftGroupList changeAircraftSettingMenu={changeAircraftSettingMenu} />;
			case AircraftSettingMenu.AIRCRAFT_LINKAGE:
				return <AircraftGroupLinkageAircraft changeCoPilotSetting={changeCoPilotSetting} changeAircraftSettingMenu={changeAircraftSettingMenu} />;
			case AircraftSettingMenu.AIRCRAFT_LINKAGE_EXTERNAL:
				return <AircraftGroupExternalLinkageAircraft changeCoPilotSetting={changeCoPilotSetting} changeAircraftSettingMenu={changeAircraftSettingMenu} />;
			case AircraftSettingMenu.USER_GROUP_LINKAGE:
				return <AircraftGroupLinkageUserGroup changeCoPilotSetting={changeCoPilotSetting} changeAircraftSettingMenu={changeAircraftSettingMenu} />;
			default:
				return <></>
		}
	}

	return (
		<div className={clsx(classes.settingTopBox)} style={{ height: '100%' }}>
			<Box className={classes.settingTab}>
				<StyledTabs
					value={value}
					onChange={handleChange}
					variant="scrollable"
					scrollButtons="auto"
				>
					<StyledTab label={t('Aircraft List')} />
					<StyledTab label={t('Aircraft Group List')} />
					<StyledTab label={t('Aircraft - Aircraft Group Linkage [company]')} />
					<StyledTab label={t('Aircraft - Aircraft Group Linkage [external]')} />
					<StyledTab label={t('Aircraft Group - User Group Linkage')} />
				</StyledTabs>
			</Box>
			<Box className={classes.settingBody}>
				<Pager />
			</Box>
		</div>
	);
}
